if (!customElements.get('sender-inventory-signal')) {
  customElements.define(
    'sender-inventory-signal',
    class SenderInventorySignal extends HTMLElement {
      connectedCallback() {
        this.variants = this.readVariants();
        this.boundDomVariantChange = this.handleDomVariantChange.bind(this);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            this.updateForVariant(data?.variant?.id);
          });
        }

        document.addEventListener('variant:change', this.boundDomVariantChange);
      }

      disconnectedCallback() {
        this.unsubscribeVariant?.();
        document.removeEventListener('variant:change', this.boundDomVariantChange);
      }

      readVariants() {
        try {
          return JSON.parse(this.querySelector('[data-sender-inventory-variants]')?.textContent || '[]');
        } catch (error) {
          console.warn('SENDER inventory signal: variant data could not be read.', error);
          return [];
        }
      }

      handleDomVariantChange(event) {
        this.updateForVariant(event.detail?.variant?.id || event.detail?.variantId);
      }

      updateForVariant(variantId) {
        if (!variantId) return;

        const variant = this.variants.find((item) => String(item.id) === String(variantId));
        if (!variant) return;

        const threshold = Math.max(1, Number(this.dataset.lowStockThreshold) || 10);
        const tracked = variant.inventoryManagement === 'shopify' && variant.inventoryPolicy !== 'continue';
        const quantity = Number(variant.inventoryQuantity) || 0;
        let state = 'available';
        let title = this.dataset.untrackedText || 'Direkt bestellbar';
        let detail = this.dataset.deliveryText || this.querySelector('[data-sender-stock-detail]')?.textContent || '';
        let badge = 'BESTELLBAR';

        if (!variant.available) {
          state = 'sold-out';
          title = this.dataset.soldOutText || 'Aktuell nicht verfügbar';
          detail = 'Derzeit nicht bestellbar.';
          badge = 'AUSVERKAUFT';
        } else if (tracked && quantity <= 0) {
          state = 'sold-out';
          title = this.dataset.soldOutText || 'Aktuell nicht verfügbar';
          detail = 'Derzeit nicht bestellbar.';
          badge = 'AUSVERKAUFT';
        } else if (tracked && quantity <= threshold) {
          state = 'low';
          title = `${this.dataset.lowStockPrefix || 'Nur noch'} ${quantity} ${
            this.dataset.lowStockSuffix || 'Stück verfügbar'
          }`;
          badge = 'BEGRENZTER BESTAND';
        } else if (tracked) {
          state = 'in-stock';
          title = this.dataset.inStockText || 'Auf Lager und versandbereit';
          badge = 'VERSANDBEREIT';
        }

        this.dataset.state = state;
        this.dataset.selectedVariantId = String(variant.id);
        this.querySelector('[data-sender-stock-title]').textContent = title;
        this.querySelector('[data-sender-stock-detail]').textContent = detail;
        this.querySelector('[data-sender-stock-badge]').textContent = badge;
      }
    }
  );
}

